import React from "react";

const Footer = () => {
    return ( 
        <>
            <div className="srvice mt-5 pb-5" style={{backgroundColor: "#0f3460"}}>
        <div className="container overflow-hidden text-center">
  <div className="row">
    <div className="col-10 col-md-6 col-lg-3 mb-4 pt-5">
      <div className="p-3 text-start">
      <h3 className="p-2 text-white fw-bolder" >Multimart</h3>
      <p className="text-white-50">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Auctor libero id et, in gravida. Sit diam duis
         mauris nulla cursus. Erat et lectus vel ut sollicitudin elit at amet.</p>
      </div>
    </div>
    <div className="col-10 col-md-6 col-lg-3 mb-4 pt-5">
      <div className="p-3 text-start">
      <h3 className="p-2 text-white">About Us</h3>
      <p className="text-white-50">Careers</p>
      <p className="text-white-50">Our Stores</p>
      <p className="text-white-50">Our Careers</p>
      <p className="text-white-50">Terms & Conditions</p>
      <p className="text-white-50">Privacy Policy</p>
      </div>
    </div>
    <div className="col-10 col-md-6 col-lg-3 mb-4 pt-5">
      <div className="p-3 text-start">
      <h3 className="p-2 text-white" >Customer Care</h3>
      <p className="text-white-50">Help Center</p>
      <p className="text-white-50">How to Buy</p>
      <p className="text-white-50">Track Your Order</p>
      <p className="text-white-50">Corporate & Bulk Purchasing</p>
      <p className="text-white-50">Returns & Refunds</p>
      </div>
    </div>
    <div className="col-10 col-md-6 col-lg-3 mb-4 pt-5">
      <div className="p-3 text-start">
      <h3 className="p-2 text-white">Contact Us</h3>
      <p className="text-white-50">70 Washington Square South, New York, NY 10012, United States</p>
      <p className="text-white-50">Email: uilib.help@gmail.com</p>
      <p className="text-white-50">Phone: +1 1123 456 780</p>
      </div>
    </div>
  </div>
</div>
        </div>
        </>
     );
}
 
export default Footer;